import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { AccountancySendEmailMultiCommand, AccountancySendEmailMultiCommandHandlerBase } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(AccountancySendEmailMultiCommand)
@Injectable({ providedIn: 'root'})
export class AccountancySendEmailMultiCommandHandler {
    private commandHandler: AccountancySendEmailMultiCommandHandlerBase;

    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new AccountancySendEmailMultiCommandHandlerBase(http);
    }

    public async handleAsync(params: AccountancySendEmailMultiCommand): Promise<void> {
        await this.commandHandler.handleAsync(params);
    }
}
